<template>
  <div>
    <div class="container">
      <el-input v-model="searchByName" placeholder="搜索型号" size="mini" />
    </div>

    <div class="container">
      <el-table :data="tableDataPagination" size="mini" style="width: 100%" border stripe>
        <el-table-column prop="rank" label="排名" width="73px"></el-table-column>
        <el-table-column prop="name" label="型号">
          <template slot-scope="scope">
            <template v-if="scope.row.link && scope.row.link.href">
              <a :href="scope.row.link.href" target="_blank" class="a">
                {{ scope.row.name }}
              </a>
              <img class="h" src="../assets/hot.gif" />
            </template>
            <template v-else>{{ scope.row.name }}</template>
          </template>
        </el-table-column>
        <el-table-column prop="percent" :label="percentLabel" style="width: 50%">
          <template slot-scope="scope">
            <el-progress :color="progressColor" :percentage="scope.row.progress" :format="formatPercentage" />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="container">
      <el-pagination
        :page-sizes="[10, 20, 50, 100, 200, 500]"
        :page-size="pageSize"
        :current-page="pageNo"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        size="mini"
        layout="total, sizes, prev, next, jumper">
      </el-pagination>
    </div>

  </div>
</template>

<script>

export default {
  name: 'CpuBenchmarksByRank',
  props: {
    globalConfig: Object,
    scoreType: Number,
    selectCate: Array,
    cpuBenchmarksList: Array
  },
  data () {
    return {
      total: 0,
      pageNo: 1,
      pageSize: 10,
      searchByName: ''
    }
  },
  watch: {
    tableData (v) {
      this.total = v.length
    }
  },
  computed: {
    percentLabel () {
      if (this.scoreType === 0) {
        return '单核i9-13900KF 100分'
      } else {
        return '多核i9-13900KF 100分'
      }
    },
    progressColor () {
      if (this.scoreType === 0) {
        return '#67c23a'
      } else {
        return '#e6a23c'
      }
    },
    selectCateName () {
      return this.selectCate.map(v => v.name)
    },
    cpuBenchmarksSortByScoreType () {
      const list = this.cpuBenchmarksList.map(item => item)
      if (this.scoreType === 0) {
        list.sort((a, b) => a.si - b.si)
      } else {
        list.sort((a, b) => a.mi - b.mi)
      }
      return list
    },
    cpuBenchmarksFilterByName () {
      return this.cpuBenchmarksSortByScoreType.filter(item => item.name.toLowerCase().indexOf(this.searchByName.toLowerCase()) >= 0)
    },
    maxPercentageRate () {
      return this.cpuBenchmarksSortByScoreType.length <= 0
        ? 0
        : (100 / (
            this.scoreType === 0 ? this.cpuBenchmarksSortByScoreType[0].sp : this.cpuBenchmarksSortByScoreType[0].mp
          ))
    },
    tableData () {
      const list = this.cpuBenchmarksFilterByName.filter(v => this.selectCateName.indexOf(v.cate) >= 0)
      if (list.length <= 0) {
        return []
      }
      const res = []
      list.forEach(item => {
        if (this.scoreType === 0) {
          res.push({ rank: item.si, name: item.name, link: item.link, percent: item.sp, progress: item.sp * this.maxPercentageRate })
        } else {
          res.push({ rank: item.mi, name: item.name, link: item.link, percent: item.mp, progress: item.mp * this.maxPercentageRate })
        }
      })
      return res
    },
    tableDataPagination () {
      return this.pagination(this.pageNo, this.pageSize, this.tableData)
    }
  },
  methods: {
    formatPercentage (percentage) {
      if (this.maxPercentageRate <= 0) {
        return '0分'
      }
      return `${Math.round(percentage / this.maxPercentageRate) >>> 0}分`
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.pageNo = val
    },
    pagination (pageNo, pageSize, list) {
      const offset = (pageNo - 1) * pageSize
      return (offset + pageSize >= list.length) ? list.slice(offset, list.length) : list.slice(offset, offset + pageSize)
    }
  }
}
</script>

<style scoped>
.a {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}
</style>

<style>
.el-pagination {
  padding: 0;
}
.el-pagination .btn-prev, .el-pagination .btn-next {
  padding: 0;
}
.el-pagination__jump {
  margin-left: 0px;
}
.el-form-item--mini.el-form-item {
  margin-bottom: 10px;
}
.el-tabs__header {
  margin-bottom: 0;
}
</style>
